import React from 'react';
import styles from './PaymentInvoice.module.css';

const formatPaymentDate = iso => {
  if (!iso) return '—';
  return new Date(iso).toLocaleDateString('en-AU', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    timeZone: 'UTC',
  });
};

const InvoiceNotes = ({ pdfS3Key, paymentDate }) => {
  const pdfPath = pdfS3Key ? `s3://kravein-invoices/${pdfS3Key}` : '—';
  const csvPath = pdfS3Key
    ? `s3://kravein-invoices/${pdfS3Key.replace(/\.pdf$/i, '.csv')}`
    : '—';

  return (
    <div className={`card ${styles.card} ${styles.notesCard}`}>
      <div className={styles.notesTitle}>📋 Invoice Notes</div>
      <div className={styles.notesGrid}>
        <div>
          <strong>Payment Terms:</strong> Net payout will be deposited directly
          to your nominated bank account on or before{' '}
          <strong>{formatPaymentDate(paymentDate)}</strong>.
          <br />
          <br />
          <strong>GST:</strong> All amounts are <strong>GST inclusive</strong>.{' '}
          KRAVEiN&apos;s commission is inclusive of GST. Your net payout
          includes GST where applicable.
        </div>
        <div>
          <strong>S3 Document Reference:</strong>
          <br />
          <code className={styles.codeBlock}>{pdfPath}</code>
          <br />
          <code className={styles.codeBlock}>{csvPath}</code>
        </div>
      </div>
    </div>
  );
};

export default InvoiceNotes;
